import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

const FailedPayment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [counter, setCounter] = useState(20);

  const countDown = () => {
    if (counter === 0) {
      return;
    }
    setTimeout(() => {
      setCounter(counter - 1);
    }, 1000);

    return (
      <p className="auto-close">
        {t("this page will automatically close in")} {counter} {t("seconds")}
      </p>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      navigate("/order/qrcollar");
    }, 10000);
  });

  return (
    <div className="payment failed-for-payment">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="SVGRepo_iconCarrier">
          <path
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#df544d"
            strokeWidth={1.5}
          />
          <path
            d="M9 9L15 15"
            stroke="#df544d"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 9L9 15"
            stroke="#df544d"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
      <h3>{t("payment failed")}</h3>
      <p>{t("payment failed description")}</p>
      {countDown()}
      <hr />
      <Link to="/order/qrcollar">{t("try again")}</Link>
    </div>
  );
};

export default FailedPayment;
